<template>
  <k-dialog
    v-if="msg"
    class="k-toast k-flex"
    transition-name="k-toast-fade"
    disable-lock
  >
    <p class="content">{{ msg }}</p>
  </k-dialog>
</template>
<script>
import KDialog from '@com/base/Dialog';
export default {
  components: {
    KDialog
  },
  props: {
    message: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      msg: ''
    };
  },
  watch: {
    message(val) {
      if (val !== this.msg) {
        this.init();
      }
    }
  },
  methods: {
    close() {
      clearTimeout(this.time);
      this.msg = '';
      // this.$destroy();
    },
    init() {
      this.msg = this.message;
    }
  },
  mounted() {
    this.init();
    window.addEventListener('touchstart', this.close);
    this.time = setTimeout(() => {
      this.close();
    }, 3000);
  },
  beforeDestroy() {
    clearTimeout(this.time);
    window.removeEventListener('touchstart', this.close);
  }
};
</script>
<style lang="scss" scoped>
.k-toast {
  z-index: 2800;
  .content {
    z-index: 2800;
    max-width: 658px;
    padding: 15px 20px;
    border-radius: 10px;
    margin: auto;
    background: rgba(0, 0, 0, 0.75);
    color: #fff;
    text-align: center;
    font-size: 28px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
  }
}
.k-toast-fade-enter-active {
  transition: all 0.3s ease;
}
.k-toast-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.k-toast-fade-enter {
  opacity: 0;
  transform: translateY(10%);
}
.k-toast-fade-leave-to {
  opacity: 0;
  transform: translateY(-10%);
}
</style>
